const providerInfo = [
  {
    providerId: 'google.com',
    providerName: 'Google',
    providerImageUrl: 'https://cdn-icons-png.flaticon.com/512/2965/2965278.png',
  },
  {
    providerId: 'facebook.com',
    providerName: 'Facebook',
    providerImageUrl: 'https://cdn-icons-png.flaticon.com/512/124/124010.png',
  },
  {
    providerId: 'apple.com',
    providerName: 'Apple',
    providerImageUrl: 'https://cdn-icons-png.flaticon.com/512/25/25345.png',
  },
  {
    providerId: 'password',
    providerName: 'Email/password',
    providerImageUrl: 'https://cdn-icons-png.flaticon.com/512/95/95645.png',
  },
  {
    providerId: 'microsoft.com',
    providerName: 'Microsoft',
    providerImageUrl: 'https://cdn-icons-png.flaticon.com/512/732/732221.png',
  },
];

export { providerInfo };
